import Vue from 'vue'
import { Tree, Radio, Checkbox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Tree)
Vue.use(Radio)
Vue.use(Checkbox)